export const parseNumber = (value: string) => Number(value.replace(',', '.'));
